import { SLFilterToSearch, asBoolean, asString } from "./common";
import { UserFilters } from "@services/user/types";
import { getMappedValue } from "./const";

export const widgetFilterToSLFilter = (
  filters: (WidgetFilter | FilterDefinition)[] = []
): UserFilters => {
  let mapped: UserFilters = {};

  const mapValue = (
    key: string,
    filterValue: string | string[] | boolean | undefined
  ) => {
    let value: typeof filterValue;
    switch (typeof filterValue) {
      case "boolean":
        value = filterValue;
        break;
      case "string":
        value = Boolean(filterValue) ? filterValue : undefined;
        break;
      case "object":
        Array.isArray(filterValue) && filterValue.every((v) => Boolean(v))
          ? (value = filterValue)
          : (value = undefined);
      default:
        value = filterValue;
        break;
    }
    return getMappedValue(
      mapped,
      key as keyof UserFilters,
      value
    ) as UserFilters;
  };

  filters.forEach((f) => {
    mapped = mapValue(f.filterType as keyof UserFilters, f.filterValue);
  });

  return mapped;
};

export const SLFilterToWidgetFilter = (
  slFilters: UserFilters
): FilterDefinition[] => {
  const filters: FilterDefinition[] = [];
  if (slFilters["email"] !== undefined)
    filters.push({
      filterType: "email",
      filterValue: slFilters.email,
    });
  if (slFilters.firstName !== undefined) {
    filters.push({
      filterType: "firstName",
      filterValue: slFilters.firstName,
    });
  }
  if (slFilters.lastName !== undefined) {
    filters.push({
      filterType: "lastName",
      filterValue: slFilters.lastName,
    });
  }
  if (slFilters["role.id"] !== undefined) {
    filters.push({
      filterType: "role.id",
      filterValue: slFilters["role.id"],
    });
  }
  if (slFilters["author"] !== undefined) {
    filters.push({
      filterType: "author",
      filterValue: slFilters.author ? "true" : "false",
    });
  }
  return filters;
};

export const searchToSLFilter = (params: URLSearchParams): UserFilters => {
  const filters: UserFilters = {};
  asString(filters, params, ["firstName", "lastName", "email", "role.id"]);
  asBoolean(filters, params, ["author"]);
  return filters;
};

export default {
  fromDefinition: {
    toSL: widgetFilterToSLFilter,
    toSearchParams: (filters?: (WidgetFilter | FilterDefinition)[]) =>
      SLFilterToSearch(widgetFilterToSLFilter(filters)),
  },
  fromSL: {
    toDefinition: SLFilterToWidgetFilter,
    toSearchParams: (f: UserFilters) => SLFilterToSearch(f),
  },
  fromSearchParams: {
    toSL: searchToSLFilter,
    toDefinition: (params: URLSearchParams) =>
      SLFilterToWidgetFilter(searchToSLFilter(params)),
  },
};
